import { Component, Vue } from 'vue-property-decorator';
import WithRender from './UserDetails.html';
import config from "@/settings/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import { mapGetters } from 'vuex';

@WithRender
@Component({
  filters: {
    formateDate(value: string) {
      return moment(value).format('YYYY-MM-DD HH:mm A')
    }
  },
  components: {
    Loading,
    Datepicker
  },
  computed: {
    ...mapGetters("originatorStore", { currency: "getWalletCurrency" }),
  }
})
export default class UserDetails extends Vue {

  isLoading = false;
  userId="";
 
  items = [];

  fields = [
    {
      key: "claimType",
      label: "Type",
      sortable: true,
    },
    {
      key: "claimValue",
      label: "Value",
      sortable: true,
    }
  ]

  mounted() {
    this.userId = this.$route.params.userId as string;
    this.getReport();
  }

  getReport(): void {
    this.isLoading = true;
    _axios.get(`${config.gateway}admin/User/GetUserDetail?userId=${this.userId}`)
      .then(response => {
        this.items = response.data;
      })
      .catch(err => { console.error(err); })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
